/**
 * Returns the HTMLElement child of @element matching @cssSelector, or null if not found.
 */
export function domQuerySelector(element: HTMLElement | Document, cssSelector: string): HTMLElement | null {
  return <HTMLElement>element.querySelector(cssSelector) || null;
}
